<template>
  <SimpleModuleDashboard
    :module-id="Modules.PEDIDOS"
    :profile-id="Profiles.PERSONAL"
    include-php-custom
    :actions="dashboardActions"
  />
</template>

<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import Param from '@/config/parameters'
import Helper from '@/handler/helper'
import Session from '@/handler/session'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'

export default {
  components: { SimpleModuleDashboard },
  data: () => ({
    Modules,
    Profiles,
    haveReason: Helper.hasParametersAccess(Param.P54),
  }),
  computed: {
    isSeller() {
      return !!Helper.getSeller()
    },
    activeModules() {
      return Session.getSession().auth.user.permissions.modules || []
    },
    isProducts() {
      return this.activeModules.some(module => module.id === Modules.PRODUCTOS)
    },
    isCourses() {
      return this.activeModules.some(module => module.id === Modules.CURSOS)
    },
    dashboardActions() {
      const actions = []
      if(this.isProducts && !this.isSeller) actions.push({ id: 'crudOrders', reference: 'crudOrders', route: 'OrdersStaffCrudOrders', tone: 'primary' })
      if(this.isProducts && !this.isSeller) actions.push({ id: 'orderCuts', reference: 'orderCuts', route: 'OrdersStaffOrderCuts', tone: 'success' })
      if(this.isProducts && this.isSeller) {
        actions.push({ id: 'crudOrdersSeller', reference: 'crudOrdersSeller', route: 'OrdersStaffCrudOrdersSellers', tone: 'primary' })
        actions.push({ id: 'mobileOrderCreate', reference: 'mobileOrderCreate', route: 'OrdersStaffMobileOrderCreate', tone: 'success' })
      }
      if(this.isCourses && !this.isSeller) actions.push({ id: 'crudOrdersCourses', reference: 'crudOrdersCourses', route: 'OrdersStaffCrudOrdersCourses', tone: 'secondary' })
      if(this.haveReason && !this.isSeller) actions.push({ id: 'crudOrdersReason', reference: 'crudOrdersReason', route: 'OrdersStaffReason', tone: 'warning', group: 'Configuraciones' })
      if(!this.isSeller) actions.push({ id: 'configuration', reference: 'configuration', route: 'OrdersStaffConfiguration', tone: 'secondary', group: 'Configuraciones' })
      return actions
    },
  },
}
</script>
